import React,{Component} from 'react';
import firebase from '../../config'
import { Menu, Dropdown, Button, message, Tooltip } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Form, Input, InputNumber} from 'antd';
import Box from '@material-ui/core/Box'


const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  


export default class Add extends Component{
    constructor(props){
        super(props)
        
        this.state={
            habits:[],
            risk:[],
            type:null,
            selectedHabit:null,
            selecetedRisk:null,
            t:["health_risk","habits"],
            parameters:[],

        }
    }
    componentDidMount(){
        this.fun();
    }

      fun(){
        const db = firebase.firestore();
        let temp = [];
        let ctr =0;
        const getSubCollections = firebase
        .functions()
        .httpsCallable('getSubCollections');
        
        getSubCollections({ docPath: 'tests/health_risk' })
        .then(async (result) => {
          var collections = result.data.collections;
          console.log(collections)
          this.setState({
              risk : collections
          })
        })
        .catch(function(error) {
          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          var details = error.details;
          console.log(code,message,details)
          // ...
        });
        
        getSubCollections({ docPath: 'tests/habits' })
        .then(async (result) => {
          var collections = result.data.collections;
          this.setState({
                habits : collections
          })
        })
        .catch(function(error) {
          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          var details = error.details;
          console.log(code,message,details)
          // ...
        });
             
      }
    habitClick = (e) => {
        this.setState({
            selectedHabit:e.key
        })

      
    }
    habitMenu = ()=>{
        return <Menu onClick={this.habitClick}>
            {   
                this.state.habits.map(ek => {
                    return <Menu.Item key={ek}>{ek}</Menu.Item>
                })
            }
      </Menu>
    }
    healthClick = (e) => {
        this.setState({
            selecetedRisk:e.key
        })

      
    }
    healthMenu = ()=>{
        return <Menu onClick={this.healthClick}>
            {   
                this.state.risk.map(ek => {
                    return <Menu.Item key={ek}>{ek}</Menu.Item>
                })
            }
      </Menu>
    }
    handleSubmit = (values)=>{
        values.parameters = JSON.stringify(this.state.parameters)
        var obj = {...values};
        const db = firebase.firestore();
        let ref  =  db.collection('tests');
        let ref2 = db.collection("search")
        if(this.state.selectedHabit !== null || this.state.selecetedRisk !== null){
          console.log("habit",this.state)
          ref.doc("habits").collection(this.state.selectedHabit).add(values).then((docref) =>{
            obj.id = docref.id;
            obj.type= "habits"
            obj.category = this.state.selectedHabit
            var name = obj.name;
            ref2.doc(name).set(obj);
            

            if(this.state.selecetedRisk !== null){
              console.log("risk",this.state)
              ref.doc("health_risk").collection(this.state.selecetedRisk).add(values).then((docref) => {
                obj.id = docref.id;
                obj.type= "health_risk"
                obj.category = this.state.selectedHabit
                var name = obj.name;
                ref2.doc(name).set(obj);
                alert("Added successfuly")
              })
            }
            else alert('added successfully')
          })
        }

        if(this.state.selectedHabit === null &&this.state.selecetedRisk === null){
          ref.add(values).then((docref) => {
            obj.id = docref.id;
            obj.type= null
            obj.category = null
            var name = obj.name;
            ref2.doc(name).set(obj);
            alert("Added successfuly")
          })
        }

    }
    addForm = () =>{
      var t = ""
      var params = []
            return (
                <Form {...layout} name="add" onFinish={ this.handleSubmit} >
                <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item  label="Price" name="price" rules={[{ required:true }]}>
                  <Input />
                </Form.Item>
                <Form.Item  label="Report Days" name="report_days" rules={[{ type: 'number',required:true,min: 0, max: 99 }]}>
                  <InputNumber />
                </Form.Item>
                <Form.Item label="overview" name="overview" >
                  <Input />
                </Form.Item>
                <Form.Item  label="details" name="details">
                  <Input.TextArea />
                </Form.Item>
                <h3>Parameters</h3>
                <Input placeholder="Add parameter" defaultValue={t} onChange={(e) => t=e.target.value}/>
                <Box display="flex">
                  <Button color="primary" onClick={() => {params.push(t); t=""}}>Add Parameter</Button>
                  <Button color="primary" onClick={() => this.setState({parameters:params},console.log(this.state))}>Done</Button>
                </Box>
                
                <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            )
    }
    render(){
        console.log(this.state)
        return(
            <div>
                <Box display="flex" justifyContent="space-between" flexDirection="column">
                    <Box textAlign="center" fontSize="20px" fontWeight="bold">Add Test</Box>
                    <Box flexDirection="column">
                        <Box display="flex" justifyContent="center" flexDirection="row">
                            <Box>
                                <Dropdown trigger="click" overlay={this.habitMenu}>
                                    <Button>{this.state.selectedHabit===null ? "select habbit" : this.state.selectedHabit}</Button>
                                </Dropdown>
                            </Box>
                            <Box>
                                <Dropdown trigger="click" overlay={this.healthMenu}>
                                    <Button>{this.state.selecetedRisk===null ? "select health risk" : this.state.selecetedRisk}</Button>
                                </Dropdown>
                            </Box>
                        </Box>
                    </Box>
                    <Box justifyContent="flex-start">
                        <this.addForm></this.addForm>
                    </Box>

                </Box>


               
            </div>
        )
    }
}